import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import CustomerGateway from '~apis/customer';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TGetCustomerTransactionsReduxParams } from '~types/feat/customer';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetCustomerTransactions(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerGetCustomerTransactionsAttempt', handleGetCustomerTransactions, api);
}

function* handleGetCustomerTransactions(api: CustomerGateway, data: PayloadAction<TGetCustomerTransactionsReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const index = reduxState.customer.customerTransactions.index;
    const { customerId } = data.payload;

    if (!customerId || (!index && index !== 0)) {
        yield put(combinedActions.customerGetCustomerTransactionsFailure(ErrorMessages.FilterInvalidStatusError));
        toast.error(ErrorMessages.FilterInvalidStatusError);
        return;
    }

    const response = yield* call([api, api.getCustomerTransactions], {
        authToken,
        index,
        customerId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerGetCustomerTransactionsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerGetCustomerTransactionsSuccess(response.data));
    }
}
